import React from "react";
import { useTranslation } from "react-i18next";
import AddButton from "@components/buttons/AddButton";

export default function DisciplinaryForm(props) {
  const {
    toggleModalDisciplinaryForm,
   } = props;

  const { t: translator } = useTranslation("disciplinary.disciplinary");

  return (
    <div className="arh-mb-8">
      <AddButton
        label={translator("Ajouter un suivi disciplinaire")}
        onClick={toggleModalDisciplinaryForm}
        color="arh-bg-greenColor hover:arh-bg-darkGreenColor"
        labelClass="arh-text-xs"
        disabled={false}
      />
    </div>
  );
}
